import React from "react";
import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function MobileCallBar() {
  return (
    <div
      data-testid="mobile-call-bar"
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden grid grid-cols-2 shadow-[0_-4px_16px_rgba(15,23,42,0.18)]"
    >
      <a
        href={`tel:${COMPANY.phoneTel}`}
        data-testid="sticky-call-now-button"
        className="bg-[#0284C7] text-white text-center py-4 font-semibold flex items-center justify-center gap-2"
      >
        <Phone className="h-4 w-4" strokeWidth={2} />
        Call Now
      </a>
      <Link
        to="/quote"
        data-testid="sticky-quote-button"
        className="bg-[#0F172A] text-white text-center py-4 font-semibold flex items-center justify-center gap-2"
      >
        <FileText className="h-4 w-4" strokeWidth={2} />
        Free Quote
      </Link>
    </div>
  );
}
